export function getIsViewingApplicantDeleting({
  applicant,
  deletingApplicantId,
}) {
  return String(applicant.id) === String(deletingApplicantId)
}
